import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _deleteReferringCustomerRequest = {};
var _deleteReferringCustomerResponse = {};
var _generateReferringCustomerForContactRequest = {};
var _generateReferringCustomerForContactResponse = {
    referringCustomer: '_referringCustomer',
};
var _getReferringCustomerByReferralCodeRequest = {};
var _getReferringCustomerByReferralCodeResponse = {
    referringCustomer: '_referringCustomer',
};
var _getReferringCustomerRequest = {};
var _getReferringCustomerResponse = {
    referringCustomer: '_referringCustomer',
};
var _queryReferringCustomersRequest = {};
var _queryReferringCustomersResponse = {
    referringCustomers: '_referringCustomer',
};
var _referringCustomer = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
function resolveWixLoyaltyReferralCustomerV1ReferringCustomersUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/referral_customers',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/referral_customers',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/referral_customers',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/referral_customers',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/referral_customers',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/referral_customers',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/referral_customers',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/referral_customers',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/referral-customers',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/referral-customers',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/referral-customers',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a new referring customer or returns an existing one for the provided contact ID.
 *
 * You can use `"me"` instead of a specific contact ID to generate a referring customer for the current identity's contact.
 *
 * See [About Identities](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities) to learn more about identities.
 */
export function generateReferringCustomerForContact(payload) {
    var _a = serializer(_generateReferringCustomerForContactRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_generateReferringCustomerForContactResponse, { _referringCustomer: _referringCustomer }).fromJSON;
    function __generateReferringCustomerForContact(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.referring_customer',
            method: 'POST',
            methodFqn: 'wix.loyalty.referral.customer.v1.ReferringCustomers.GenerateReferringCustomerForContact',
            url: resolveWixLoyaltyReferralCustomerV1ReferringCustomersUrl({
                protoPath: '/v1/referring-customers',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __generateReferringCustomerForContact.fromReq = fromReq;
    __generateReferringCustomerForContact.__isAmbassador = true;
    return __generateReferringCustomerForContact;
}
/** Retrieves a referring customer by ID. */
export function getReferringCustomer(payload) {
    var _a = serializer(_getReferringCustomerRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getReferringCustomerResponse, {
        _referringCustomer: _referringCustomer,
    }).fromJSON;
    function __getReferringCustomer(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.referring_customer',
            method: 'GET',
            methodFqn: 'wix.loyalty.referral.customer.v1.ReferringCustomers.GetReferringCustomer',
            url: resolveWixLoyaltyReferralCustomerV1ReferringCustomersUrl({
                protoPath: '/v1/referring-customers/{referringCustomerId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getReferringCustomer.fromReq = fromReq;
    __getReferringCustomer.__isAmbassador = true;
    return __getReferringCustomer;
}
/** Retrieves a referring customer by referral code. */
export function getReferringCustomerByReferralCode(payload) {
    var _a = serializer(_getReferringCustomerByReferralCodeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getReferringCustomerByReferralCodeResponse, { _referringCustomer: _referringCustomer }).fromJSON;
    function __getReferringCustomerByReferralCode(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.referring_customer',
            method: 'GET',
            methodFqn: 'wix.loyalty.referral.customer.v1.ReferringCustomers.GetReferringCustomerByReferralCode',
            url: resolveWixLoyaltyReferralCustomerV1ReferringCustomersUrl({
                protoPath: '/v1/referring-customers/code/{referralCode}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getReferringCustomerByReferralCode.fromReq = fromReq;
    __getReferringCustomerByReferralCode.__isAmbassador = true;
    return __getReferringCustomerByReferralCode;
}
/**
 * Retrieves a list of referred friends, given the provided paging, filtering, and sorting.
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryReferringCustomers(payload) {
    var _a = serializer(_queryReferringCustomersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryReferringCustomersResponse, {
        _referringCustomer: _referringCustomer,
    }).fromJSON;
    function __queryReferringCustomers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.referring_customer',
            method: 'POST',
            methodFqn: 'wix.loyalty.referral.customer.v1.ReferringCustomers.QueryReferringCustomers',
            url: resolveWixLoyaltyReferralCustomerV1ReferringCustomersUrl({
                protoPath: '/v1/referring-customers/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryReferringCustomers.fromReq = fromReq;
    __queryReferringCustomers.__isAmbassador = true;
    return __queryReferringCustomers;
}
/**
 * Deletes a referring customer by ID.
 *
 * You must provide the latest `revision` to prevent conflicting changes.
 */
export function deleteReferringCustomer(payload) {
    var _a = serializer(_deleteReferringCustomerRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteReferringCustomerResponse, {}).fromJSON;
    function __deleteReferringCustomer(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.referral.v1.referring_customer',
            method: 'DELETE',
            methodFqn: 'wix.loyalty.referral.customer.v1.ReferringCustomers.DeleteReferringCustomer',
            url: resolveWixLoyaltyReferralCustomerV1ReferringCustomersUrl({
                protoPath: '/v1/referring-customers/{referringCustomerId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteReferringCustomer.fromReq = fromReq;
    __deleteReferringCustomer.__isAmbassador = true;
    return __deleteReferringCustomer;
}
//# sourceMappingURL=http.impl.js.map